import htmlTemplate from '../Testimonial/htmlTemplate';

const loadTestimonials = () => {
  return fetch('/assets/testimonials/list.json?siteId=61&limit=10')
    .then(response => response.json())
    .then(responseData => {
      const { testimonials } = responseData.data;

      // document
      //   .querySelector('[data-testimonials-widget-js]') // eslint-disable line
      //   .removeChild(document.querySelector('.Loader'));
      const testimonialsWidget = document.querySelector('[data-testimonials-widget-js]');
      const tmNodes = testimonials.map(tm => htmlTemplate(tm)).join('');

      if (testimonialsWidget) {
        testimonialsWidget.insertAdjacentHTML('afterbegin', tmNodes);
      }
      // document
      //   .querySelector('[data-testimonials-widget-js]')
      //   .insertAdjacentHTML('afterbegin', tmNodes);
    });
};

export default loadTestimonials;
